<template>
  <div class="assessment">
    <loading :active="showGlobalLoader" :is-full-page="true"></loading>
    <md-button
      v-if="isNew && (isAdmin || isFaculty)"
      @click="startAssesment"
      class="md-accent md-raised"
    >
      <span class="button-label">+ Start assessment</span>
    </md-button>
    <md-button v-else-if="!isNew" @click="onEdit" class="md-icon-button">
      <md-icon>edit</md-icon>
    </md-button>
    <md-button v-if="!isNew && (isAdmin || isFaculty)"
      @click="showDelete(submission.id)"
      class="md-icon-button"
      ><md-icon>delete</md-icon></md-button>
     <md-dialog-confirm
      class="confirm"
      :md-active.sync="confirmDelete"
      md-title=""
      md-content="Are you sure to delete this assessment?"
      md-confirm-text="Yes, Delete!"
      md-cancel-text="No"
      @md-cancel="onDeleteCancel"
      @md-confirm="onDeleteConfirm"
    />
    <md-dialog :md-active.sync="confirmNewAssessment">
      <md-dialog-content>
        <h3 class="who-are-you-assessin">The assessment for the same start date exists in the system. Please select an assessment or create a new one.</h3>
        <table class="assessment-table">
          <tr>
            <th>Start Date</th>
            <th>Faculty</th>
            <th>Student</th>
            <th></th>
          </tr>
          <tr :key="assessment.id" v-for="assessment in confirmAssessmentList">
            <td>{{ $moment.utc(+assessment.startDate).format('MM/DD/YYYY') }}</td>
            <td>{{ assessment.creator.firstName }} {{ assessment.creator.lastName }}</td>
            <td>{{ assessment.submissionsAll.edges[0].user.firstName }} {{ assessment.submissionsAll.edges[0].user.lastName }}</td>
            <td>
              <a href="javascript:void(0)" @click="goToAssessment(assessment.id)">Edit</a>
            </td>
          </tr>
        </table>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="onConfirmNewAssessmentCancel">Cancel</md-button>
        <md-button class="md-primary" @click="onConfirmNewAssessmentNew">Create New</md-button>
      </md-dialog-actions>
    </md-dialog>
    <md-dialog :md-active.sync="showDialogSelectUserType">
      <md-dialog-content>
        <h3 class="who-are-you-assessin">Who are you assessing?</h3>
        <assessment-user-type-select
          v-model="assessment_user_type"
        />
      </md-dialog-content>
    </md-dialog>
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>
        <span v-if="isNew">Select</span>
        <span v-else>Edit</span> Assessment details:
      </md-dialog-title>
      <md-dialog-content>
        <assessment-type-select-autocomplete
          @template="updateTemplate"
          :variation="assessment_user_type"
          :error-class="messageClassAssessmentType"
          :required="true"
        />
        <div v-show="assessment_type" class="md-layout">
          <div v-if="isAdmin" class="md-layout-item p10">
            <ApolloQuery
              ref="users"
              :query="require('../graphql/Users.gql')"
              :variables="{
                offset: 0,
                limit: 0,
                role: 'faculty',
              }"
            >
              <template slot-scope="{ result: { loading, error, data } }">
                <!-- Loading -->
                <div v-if="loading" class="loading apollo">
                  <loading :active="true" :is-full-page="false"></loading>
                  <md-field class="md-field-select">
                    <label>Faculty</label>
                    <md-select class="students" v-model="student">
                      <md-option value></md-option>
                    </md-select>
                  </md-field>
                </div>

                <!-- Error -->
                <div v-else-if="error" class="error apollo">
                  An error occured
                </div>

                <!-- Result -->
                <div v-else-if="data" class="position-relative">
                  <!-- <md-autocomplete v-model="student" :value="student" @md-selected="onUserSelect" :md-options="data.users.edges" md-dense>
                <label>Student</label>
                <template slot="md-autocomplete-item" slot-scope="{ item }">{{ item.firstName }} {{ item.lastName }}</template>
                  </md-autocomplete>-->
                  
                  <md-autocomplete :class="messageClassFaculty" @md-opened="resizeWindow" @input="if ($event == '') {faculty = null}" @md-selected="faculty = $event ? $event.id : null" _v-model="facultyAuto" :md-options="getSanitizedFaculties(data.users.edges)" >
                    <label>Faculty</label>
                    <template slot="md-autocomplete-item" slot-scope="{ item }">{{ item.name }}</template>
                    <span class="md-error">Please fill Faculty</span>
                  </md-autocomplete>
                  <!--md-field
                    class="md-field-select"
                    :class="messageClassFaculty"
                  >
                    <label>Faculty</label>
                    <md-select class="students" v-model="faculty">
                      <md-option
                        :key="user.id"
                        :value="user.id"
                        v-for="user in data.users.edges"
                        >{{ user.firstName }} {{ user.lastName }}</md-option
                      >
                    </md-select>
                    <span class="md-error">Please fill Faculty</span>
                  </md-field -->
                </div>
                <!-- No result -->
                <div v-else class="no-result apollo">No result</div>
              </template>
            </ApolloQuery>
          </div>
          <div class="md-layout-item p10">
            <ApolloQuery
              ref="groups"
              :query="require('../graphql/Groups.gql')"
              :variables="{ offset: 0, limit: 0, filter: { status: 1, withResidentsOnly: isResident }}"
            >
              <template slot-scope="{ result: { loading, error, data } }">
                <!-- Loading -->
                <div v-if="loading" class="loading apollo">
                  <loading :active="true" :is-full-page="false"></loading>
                  <md-field class="md-field-select">
                    <label for="group">Group</label>
                    <md-select v-model="group" name="group" id="group">
                      <md-option value></md-option>
                    </md-select>
                  </md-field>
                </div>

                <!-- Error -->
                <div v-else-if="error" class="error apollo">
                  An error occured
                </div>

                <!-- Result -->
                <div v-else-if="data" class="position-relative">
                  <md-autocomplete :class="messageClassGroup" @md-opened="resizeWindow" @input="if ($event == '') {group = null}" @md-selected="group = $event ? $event.id : null" _v-model="facultyAuto" :md-options="getSanitizedGroups(data.groups.edges)" >
                    <label>Group</label>
                    <template slot="md-autocomplete-item" slot-scope="{ item }">{{ item.name }}</template>
                    <span class="md-error">Please fill group</span>
                  </md-autocomplete>
                  <!-- md-field class="md-field-select" :class="messageClassGroup">
                    <label for="group">Group</label>
                    <md-select @md-opened="resizeWindow" v-model="group" name="group" id="group">
                      <md-option
                        :key="group.id"
                        v-for="group in data.groups.edges"
                        :value="group.id"
                        >{{ group.label }}</md-option
                      >
                    </md-select>
                    <span class="md-error">Please fill group</span>
                  </md-field -->
                </div>
                <!-- No result -->
                <div v-else class="no-result apollo">
                  <loading :active="true" :is-full-page="false"></loading>
                  <md-field class="md-field-select">
                    <label for="group">Group</label>
                    <md-select v-model="group" name="group" id="group">
                      <md-option value></md-option>
                    </md-select>
                  </md-field>
                </div>
              </template>
            </ApolloQuery>
          </div>
          <div class="md-layout-item p10">
            <ApolloQuery
              ref="users"
              @result="onStudentResult"
              :query="require('../graphql/Users.gql')"
              :variables="{
                offset: 0,
                limit: 0,
                filter: { group: !group || group == '' ? -1 : group, status: 1, group_status: 1 },
                role: 'student',
                resident: isResident
              }"
            >
              <template slot-scope="{ result: { loading, error, data } }">
                <!-- Loading -->
                <div v-if="loading" class="loading apollo">
                  <loading :active="true" :is-full-page="false"></loading>
                  <md-field class="md-field-select">
                    <label>Student</label>
                    <md-select class="students" v-model="student">
                      <md-option value></md-option>
                    </md-select>
                  </md-field>
                </div>

                <!-- Error -->
                <div v-else-if="error" class="error apollo">
                  An error occured
                </div>

                <!-- Result -->
                <div v-else-if="data" class="position-relative">
                  <loading
                    :active.sync="showStudentLoader"
                    :is-full-page="false"
                  ></loading>
                  <!-- <md-autocomplete v-model="student" :value="student" @md-selected="onUserSelect" :md-options="data.users.edges" md-dense>
                <label>Student</label>
                <template slot="md-autocomplete-item" slot-scope="{ item }">{{ item.firstName }} {{ item.lastName }}</template>
                  </md-autocomplete>-->
                  <md-autocomplete @md-opened="resizeWindow" @input="if ($event == '') {student = null}" @md-selected="student = $event ? $event.id : null" _v-model="facultyAuto" :md-options="getSanitizedFaculties(data.users.edges)" >
                    <label>Student</label>
                    <template slot="md-autocomplete-item" slot-scope="{ item }">{{ item.name }}</template>
                  </md-autocomplete>
                  <!-- md-field class="md-field-select">
                    <label>Student</label>
                    <md-select class="students" v-model="student">
                      <md-option
                        :key="user.id"
                        :value="user.id"
                        v-for="user in data.users.edges"
                        >{{ user.firstName }} {{ user.lastName }}</md-option
                      >
                    </md-select>
                  </md-field -->
                </div>
                <!-- No result -->
                <div v-else class="no-result apollo">
                  <loading :active="true" :is-full-page="false"></loading>
                  <md-field class="md-field-select">
                    <label>Student</label>
                    <md-select class="students" v-model="student">
                      <md-option value></md-option>
                    </md-select>
                  </md-field>
                </div>
              </template>
            </ApolloQuery>
          </div>
        </div>
        <div class="md-layout">
          <div class="md-layout-item p10">
            <md-field
              class="md-field-select"
              :class="messageClassDate"
              v-if="assessment_type == 'monthly'"
            >
              <label>Month</label>
              <md-select
                class="time"
                :value="startDateFormated"
                @input="startDate = new Date($event)"
              >
                <md-option
                  :key="index"
                  v-for="(month, index) in monthes"
                  :value="$moment.utc(month.value).format()"
                  >{{ month.month }}</md-option
                >
              </md-select>
              <span class="md-error">Please fill date</span>
            </md-field>
            <md-datepicker
              :class="messageClassDate"
              :md-open-on-focus="false"
              v-if="assessment_type == 'daily'"
              v-model="startDate"
            >
              <label>Date</label>
              <span class="md-error">Please fill date</span>
            </md-datepicker>
            <md-datepicker
              :class="messageClassEndDate"
              :md-open-on-focus="false"
              v-if="assessment_type == 'competency' || assessment_type == 'progress'"
              v-model="startDate"
            >
              <label>Start Date</label>
              <span class="md-error">Please fill date</span>
            </md-datepicker>
          </div>
          <!-- <div class="md-layout-item p10" v-if="assessment_type == 'competency' || assessment_type == 'progress'">
            <md-datepicker
              :class="messageClassEndDate"
              :md-open-on-focus="false"
              v-model="endDate"
            >
              <label>Completion Date</label>
              <span class="md-error">Please fill date</span>
            </md-datepicker>
          </div> -->
          <div class="md-layout-item p10" v-if="assessment_type == 'daily'">
            <md-field class="md-field-select">
              <label>Time of the day</label>
              <md-select class="time" v-model="time">
                <md-option value="am">AM</md-option>
                <md-option value="pm">PM</md-option>
              </md-select>
            </md-field>
          </div>
        </div>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="onCancel">Cancel</md-button>
        <md-button class="md-accent md-raised" @click="onSave"
          >+ Start assessment</md-button
        >
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import RoleMixinVue from "./RoleMixin.vue";
// import AssessmentTypeSelect from "./AssessmentTypeSelect";
import AssessmentUserTypeSelect from "./AssessmentUserTypeSelect";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import AssessmentTypeSelectAutocomplete from './AssessmentTypeSelectAutocomplete.vue';
export default {
  mixins: [RoleMixinVue],
  name: "AssessmentEdit",
  props: ["assessment", "show", "isNew", "user", "create", "isAdmin", "submission"],
  components: {
    // AssessmentTypeSelect,
    AssessmentUserTypeSelect,
    Loading,
    AssessmentTypeSelectAutocomplete,
  },
  mounted() {
    this.$material.locale.dateFormat = "MM/dd/yyyy";
    if (window.location.hash == "#create") {
      if (this.isNew) {
        this.startAssesment();
      }
    }
  },
  computed: {
    startDateFormated() {
      return this.$moment.utc(this.startDate).format();
    },
    messageClassLabel() {
      return {
        "md-invalid": false,
      };
    },
    messageClassGroup() {
      return {
        "md-invalid": this.validate && (!this.group || this.group.length == 0),
      };
    },
    messageClassDate() {
      return {
        "md-invalid":
          this.validate && (!this.startDate || this.startDate.getTime() == 0),
      };
    },
    messageClassAssessmentType() {
      return {
        "md-invalid":
          this.validate && !this.template,
      };
    },
    messageClassEndDate() {
      return {
        "md-invalid":
          false && this.validate && (!this.endDate || this.endDate.getTime() == 0),
      };
    },
    messageClassFaculty() {
      return {
        "md-invalid": this.validate && !this.faculty,
      };
    },
    isValid() {
      if (this.isAdmin) {
        return (
          this.startDate &&
          this.startDate.getTime() &&
          this.group &&
          this.group.length &&
          this.faculty &&
          this.template
        );
      }
      return this.startDate && this.startDate.getTime() && this.group.length;
    },
    monthes() {
      let monthes = [];
      for (let i = -1; i <= 11; i++) {
        let date = new Date();
        date.setUTCMonth(i);
        date.setUTCDate(1);
        date.setUTCHours(0);
        date.setUTCMinutes(0);
        date.setUTCSeconds(0);
        date.setUTCMilliseconds(0);
        //date.setYear(2019)
        // if (i == 11) {
        //   date.setYear(date.getUTCFullYear() - 1);
        // }
        monthes.push({
          month: this.$moment.utc(date).format("MMMM") + ' ' + date.getUTCFullYear(),
          value: date,
        });
      }
      return monthes;
    },
    isResident() {
      return this.assessment_user_type == 'resident';
    }
  },
  data() {
    return {
      showGlobalLoader: false,
      confirmNewAssessment: false,
      confirmAssessmentList: [],
      endDate: this.assessment && this.assessment.endDate
          ? new Date(parseInt(this.assessment.endDate))
          : '',
      confirmDelete: false,
      submission_id: this.submission && this.submission.id ? this.submission.id : null,
      showStudentLoader: false,
      showDialog: false,
      showDialogSelectUserType: false,
      label:
        this.assessment && this.assessment.label ? this.assessment.label : "",
      validate: false,
      group:
        this.assessment && this.assessment.group
          ? this.assessment.group.id
          : null,
      student:
        this.assessment && this.assessment.user
          ? this.assessment.user.id
          : null,
      faculty:
        this.assessment && this.assessment.creator
          ? this.assessment.creator.id
          : null,
      facultyAuto: null,
      startDate:
        this.assessment && this.assessment.startDate
          ? new Date(parseInt(this.assessment.startDate))
          : new Date(),
      time: "am",
      assessment_type:
        this.assessment && this.assessment.type
          ? this.assessment.type
          : null,
      assessment_user_type: 'none',
      template: null,
    };
  },
  methods: {
    getSanitizedGroups(options) {
      return options.map(item => ({
        'id': item.id,
        'name': item.label,
        'toLowerCase': () => (item.label).toLowerCase(),
        'toString': () => item.label
      }));
    },
    getSanitizedFaculties(options) {
      return options.map(item => ({
        'id': item.id,
        'name': (item.firstName || '') + ' ' + (item.lastName || ''),
        'toLowerCase': () => (item.firstName + ' ' + item.lastName).toLowerCase(),
        'toString': () => item.firstName + ' ' + item.lastName
      }));
    },
    resizeWindow() {
      setTimeout(()=>{
        window.dispatchEvent(new Event('resize'));
      }, 50);
    },
    startAssesment() {
      this.assessment_type = null;
      this.assessment_user_type = 'none';
      this.template = null;
      this.validate = false;
      this.group =
        this.assessment && this.assessment.group
          ? this.assessment.group.id
          : null;
      this.student =
        this.assessment && this.assessment.user
          ? this.assessment.user.id
          : null;
      this.faculty =
        this.assessment && this.assessment.creator
          ? this.assessment.creator.id
          : null;
      this.showDialogSelectUserType = true;
    },
    onDeleteCancel() {
      this.confirmDelete = false;
    },
    showMainDialog() {
      this.showDialogSelectUserType = false;
      this.showDialog = true;
    },
    showDelete(id) {
      this.submission_id = id;
      this.confirmDelete = true;
    },
    onDeleteConfirm() {
      this.confirmDelete = false;
      this.delete();
    },
    onStudentResult() {
      this.showStudentLoader = false;
      setTimeout(()=>{
        console.log('resize');
        window.dispatchEvent(new Event('resize'));
      }, 50);
    },
    updateTemplate(val) {
      this.assessment_type = val ? val.type : null
      this.template = val;
      this.updateStartDate();
    },
    updateStartDate() {
      if (this.assessment_type == "monthly") {
        let date = new Date();
        date.setUTCMonth(date.getMonth());
        date.setUTCDate(1);
        date.setUTCHours(0);
        date.setUTCMinutes(0);
        date.setUTCSeconds(0);
        date.setUTCMilliseconds(0);
        this.startDate = date;
      } else {
        let date_str = this.$moment().format('YYYY-MM-DD');
        let timestamp = this.$moment(date_str).utc().valueOf();
        this.startDate = new Date(timestamp);
      }
    },
    onEdit() {
      this.$router.push({
        name: "assessment_user",
        params: { id: this.assessment.id, user: this.user.id },
      });
    },
    onUserSelect(item) {
      console.log(item);
    },
    onConfirmNewAssessmentCancel() {
      this.confirmNewAssessment = false;
    },
    onConfirmNewAssessmentNew(event) {
      this.confirmNewAssessment = false;
      this.onSave(event, true);
    },
    goToAssessment(assessment_id) {
      this.showGlobalLoader = true;
      this.confirmNewAssessment = false;
      this.$router.push({
        name: "assessment_user",
        params: { id: assessment_id, user: this.student },
      });
    },
    async onSave(event, force) {
      
      this.validate = true;
      if (!this.isValid) {
        return;
      }
      this.validate = false;
      if (this.isNew) {
        let assessment = null;
        let assessments = [];
        let assessmentsWithData = [];
        if (!force) {
          this.showGlobalLoader = true;
          debugger

          await this.$apollo
            .query({
              query: require("../graphql/AssessmentsWithSubmissions.gql"),
              fetchPolicy: "no-cache",
              variables: {
                offset: 0,
                limit: 5,
                order: "id",
                direction: "DESC",
                filter: {
                  type: this.assessment_type,
                  startDate: this.$moment(this.startDate)
                    .format("YYYY-MM-DD"),
                  startTime: this.assessment_type == "daily" ? this.time : null,
                  group: this.group,
                  status: null,
                  creator: this.isAdmin && (this.assessment_type == 'daily' ||  this.assessment_type == 'monthly') ? this.faculty : null,
                  templateId: this.template.id
                },
              },
            })
            .then((data) => {
              this.showGlobalLoader = false;
              console.log(data);
              if (data.data.assessments.count > 0) {
                assessment = data.data.assessments.edges[0];
                assessments = data.data.assessments.edges;
                assessmentsWithData = data.data.assessments.edges.filter((el)=>{
                  
                  let studentSubmissions = el.submissionsAll.edges.filter((s)=>{
                    
                    return s.user && s.user.id == this.student;
                  });
                  return studentSubmissions.length;
                });
              }
            })
            .catch((error) => {
              this.showGlobalLoader = false;
              console.log(error);
            });
            
          if (assessment) {
            if (this.student) {
              this.showDialog = false;
              if (assessmentsWithData.length == 0) {
                this.$router.push({
                  name: "assessment_user",
                  params: { id: assessment.id, user: this.student },
                });
                return;
              }
              this.confirmNewAssessment = true;
              this.confirmAssessmentList = assessmentsWithData;
              return;
            }
            this.showDialog = false;
            this.$router.push({
              name: "assessment",
              params: { id: assessment.id },
            });
            return;
          }
        }
        await this.$apollo
          .mutate({
            mutation: require("../graphql/CreateAssessment.gql"),
            variables: {
              label: this.label,
              user: this.student,
              creator: this.faculty,
              group: this.group,
              startDate: this.$moment(this.startDate)
                .format("YYYY-MM-DD"),
              endDate: this.endDate != '' ? this.$moment(this.endDate)
                .format("YYYY-MM-DD") : null,
              startTime: this.assessment_type == "daily" ? this.time : null,
              type: this.assessment_type,
              templateId: this.template.id
            },
          })
          .then((data) => {
            assessment = data.data.createAssessment;
          })
          .catch(() => {
            this.validate = true;
          });
        if (assessment) {
          if (this.student) {
            this.showDialog = false;
            this.$router.push({
              name: "assessment_user",
              params: { id: assessment.id, user: this.student },
            });
            return;
          }
          this.showDialog = false;
          this.$router.push({
            name: "assessment",
            params: { id: assessment.id },
          });
          return;
        }
      } else {
        await this.$apollo.mutate({
          mutation: require("../graphql/UpdateAssessment.gql"),
          variables: {
            id: this.assessment.id,
            label: this.label,
            user: this.student,
            group: this.group,
            creator: this.faculty,
            startDate: this.$moment(new Date(this.startDate)).format(
              "YYYY-MM-DD"
            ),
            type: "daily",
            startTime: this.assessment_type == "daily" ? this.time : null,
            templateId: this.template.id
          },
        });
      }
      this.$emit("updateQuery");
      this.showDialog = false;
    },
    onCancel() {
      this.label = this.group ? this.group.label : "";
      this.status = this.group ? this.group.status : 1;
      this.showDialog = false;
    },
    async delete() {
      if (this.submission_id) {
        await this.$apollo
          .mutate({
            mutation: require("../graphql/DeleteSubmission.gql"),
            variables: {
              id: this.submission_id,
            },
          })
          .then(() => {
            this.submission_id = null;
            this.$emit("refresh-assessments", true);
            //this.$refs["users"].$apollo.queries.query.refetch();
          })
          .catch(() => {
            this.submission_id = null;
            // this.$refs["users"].$apollo.queries.query.refetch();
          });
      }
    },
  },
  watch: {
    $route (){
      this.showGlobalLoader = false;
    },
    create(val) {
      if (val == true) {
        this.startAssesment();
        this.$emit("create", false);
      }
    },
    group() {
      this.showStudentLoader = true;
      this.student = null;
    },
    assessment_user_type(val) {
      if (val == 'none') {
        return;
      }
      this.showMainDialog();
    }
  },
};
</script>